import { Backdrop, Box, Card, CircularProgress, Divider, Typography, useMediaQuery } from '@mui/material'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { DOMAIN } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { currentUserActions } from '../../redux/store'
import { getFromStorage } from '../../utils/storage'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import { mainGreen } from '../../utils/color'

export default function ImportExportHistoryByStore() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const [loadingSearch, setLoadingSearch] = useState(true)
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [products, setProducts] = useState([])

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const getProducts = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/stock/history/${currentUser.store}`,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setProducts(response.data)
				setLoadingSearch(false)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token, currentUser.store],
	)

	useEffect(() => {
		getProducts()
	}, [getProducts])

	return (
		<UserLayout>
			{loadingSearch ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Card
					sx={{
						padding: '20px 20px 10px 20px',
						background: '#fff',
					}}>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: 999,
							left: mediaMd ? 300 : 0,
						}}
						open={isViewerOpen}
						onClick={closeImageViewer}>
						<img
							loading='lazy'
							src={currentImage}
							alt='attach'
							style={{
								maxHeight: '70%',
								maxWidth: '90%',
							}}
							onClick={(e) => {
								e.stopPropagation()
							}}
						/>
					</Backdrop>
					{products?.map((prod, index) => {
						return (
							<Fragment key={index}>
								{prod.action === 'export' && prod.request.status === 'complete' && (
									<>
										<Box display='flex' alignItems='center'>
											<ArrowDropUpIcon sx={{ fontSize: '20px', color: mainGreen }} />
											<Typography>
												<span style={{ color: mainGreen, fontWeight: 'bold' }}>(+{prod.request?.quantity})</span> nhập
												từ <b>{prod.user?.name}</b>.{' '}
												{prod.note && <span style={{ fontStyle: 'italic' }}>({prod.note}).</span>}{' '}
												<span>
													Tồn: <b>{Number(prod.balanceStore)?.toFixed(1)}</b>
													kg
												</span>
											</Typography>
										</Box>
										<Box display='flex' justifyContent='flex-end' alignItems='flex-end' sx={{ mb: 1 }}>
											{prod.request.confirmPicture && (
												<img
													loading='lazy'
													src={prod.request.confirmPicture}
													onClick={(e) => {
														openImageViewer(prod.request.confirmPicture)
													}}
													width='30'
													height='30'
													style={{
														marginRight: '8px',
														marginTop: '2px',
														cursor: 'pointer',
													}}
													alt=''
												/>
											)}
											{prod?.deliveryReceiptPicture?.map((image, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={image}
														onClick={(e) => {
															openImageViewer(image)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											{prod.request?.confirmMultiPicture?.map((image, index) => {
												return (
													<img
														loading='lazy'
														key={index}
														src={image}
														onClick={(e) => {
															openImageViewer(image)
														}}
														width='30'
														height='30'
														style={{
															marginRight: '8px',
															marginTop: '2px',
															cursor: 'pointer',
														}}
														alt=''
													/>
												)
											})}
											<Typography
												style={{
													fontStyle: 'italic',
													fontSize: '12px',
													textAlign: 'right',
													marginTop: '3px',
												}}>
												- {prod.timeStamp} -
											</Typography>{' '}
										</Box>

										<Divider sx={{ mb: 1 }} />
									</>
								)}
							</Fragment>
						)
					})}
				</Card>
			)}
		</UserLayout>
	)
}
